import { scrollToConstants } from '../utils/types';

export function setScrollToId(id) {
  return dispatch =>
    dispatch({
      type: scrollToConstants.SET_SCROLL_TO_ID,
      payload: {
        id
      }
    });
}

export function resetScrollToId() {
  return dispatch =>
    dispatch({
      type: scrollToConstants.RESET_SCROLL_TO_ID,
      payload: {}
    });
}



// WEBPACK FOOTER //
// ./src/actions/scrollToActions.js